import type { Account } from 'pkg/api/models/account';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum AccountRelationTypes {
	LegalGuardian = 'legalGuardian',
	Ward = 'ward',
}

export interface AccountRelation extends Record, Dateable {
	accountId: number;
	account: Account;
	targetAccountId: number;
	targetAccount: Account;
	type: AccountRelationTypes;
	approvedAt?: number;
}
